<div>
	<span class="bid-submit-error-text" translate>auction.submit.not.authorized.internal</span>
</div>